import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { PublicNav, PublicFooter } from "./Landing";
import { requestAccess } from "../../services/publicService";
import "./Landing.css";

const TYPES = [["society", "Residential society"], ["school", "School"], ["college", "College / university"], ["mall", "Mall"], ["corporate", "Corporate office"], ["hospital", "Hospital"], ["hotel", "Hotel"], ["institution", "Institution"], ["commercial", "Commercial property"], ["fm_company", "Facility-management company"]];

const RequestAccess = () => {
  const [f, setF] = useState({ orgName: "", orgType: "society", city: "", contactName: "", phone: "", email: "", message: "", website: "" });
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const r = await requestAccess(f);
      if (r?.success) setDone(true);
      else setError(r?.message || "Could not send");
    } catch (err) {
      setError(err?.message || "Could not send");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="hh">
      <PublicNav />
      <section className="hh-section">
        <div className="hh-form">
          {done ? (
            <>
              <h1>Thank you</h1>
              <p>ManBhawan will call you on the number you gave to set up your organization's account. Once it's ready, you'll get a WhatsApp invitation and can sign in with your mobile number — no password needed.</p>
              <Link to="/" className="btn btn-outline-success">Back to HortiHub</Link>
            </>
          ) : (
            <Form onSubmit={submit}>
              <h1>Request access</h1>
              <p className="text-muted">Tell us about your society or organization. We set up your account, invite you, and you're in.</p>
              <Form.Group className="mb-3"><Form.Label>Society / organization name</Form.Label><Form.Control required value={f.orgName} onChange={set("orgName")} /></Form.Group>
              <div className="row g-2">
                <div className="col-sm-6"><Form.Group className="mb-3"><Form.Label>Type</Form.Label><Form.Select value={f.orgType} onChange={set("orgType")}>{TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</Form.Select></Form.Group></div>
                <div className="col-sm-6"><Form.Group className="mb-3"><Form.Label>City</Form.Label><Form.Control value={f.city} onChange={set("city")} placeholder="Noida, Ghaziabad, Greater Noida…" /></Form.Group></div>
              </div>
              <Form.Group className="mb-3"><Form.Label>Your name</Form.Label><Form.Control required value={f.contactName} onChange={set("contactName")} /></Form.Group>
              <div className="row g-2">
                <div className="col-sm-6"><Form.Group className="mb-3"><Form.Label>Mobile (WhatsApp)</Form.Label><Form.Control required type="tel" inputMode="numeric" value={f.phone} onChange={set("phone")} placeholder="98765 43210" /></Form.Group></div>
                <div className="col-sm-6"><Form.Group className="mb-3"><Form.Label>Email (optional)</Form.Label><Form.Control type="email" value={f.email} onChange={set("email")} /></Form.Group></div>
              </div>
              <Form.Group className="mb-3"><Form.Label>What do you need? (optional)</Form.Label><Form.Control as="textarea" rows={3} value={f.message} onChange={set("message")} placeholder="Plants for the tower back side, a gardening AMC, seasonal flowers…" /></Form.Group>
              <div className="hh-hp" aria-hidden="true"><label>Website<input tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} /></label></div>
              {error && <div className="text-danger mb-2">{error}</div>}
              <Button type="submit" variant="success" className="w-100" disabled={busy}>{busy ? "Sending…" : "Send request"}</Button>
              <div className="small text-muted mt-3">Already invited? <Link to="/login">Sign in</Link> with your mobile number.</div>
            </Form>
          )}
        </div>
      </section>
      <PublicFooter />
    </div>
  );
};

export default RequestAccess;
